
export enum MeditatorStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    PASSED = "PASSED",
    FAILED = "FAILED",
    DECLINE_PENDING = "DECLINE_PENDING",
    DECLINE_CONFIRMED = "DECLINE_CONFIRMED",
    DECLINE_REJECTED = "DECLINE_REJECTED",
}